'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _time = require('./time');

Object.defineProperty(exports, 'timeStyle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_time).default;
  }
});

var _twitter = require('./twitter');

Object.defineProperty(exports, 'twitterStyle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_twitter).default;
  }
});

var _default = require('./default');

Object.defineProperty(exports, 'defaultStyle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_default).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/javascript-time-ago/modules/style/index.js
// module id = 687
// module chunks = 0